module.exports = __webpack_public_path__ + "img/leicester-city.25bb5a94.png";